import { Badge, Divider, Flex, Skeleton, Stack, Text } from "@chakra-ui/react";
import moment from "moment";
import React, { useCallback, useContext, useEffect } from "react";
import { useQuery } from "@tanstack/react-query";
import { BusLocation, BusTime, useBusTimes } from "../../data/buses.api";
import BusTimeRow from "./BusTimeRow";

type Props = {
  atcoCode: string;
  showScheduledTime?: boolean;
  limit?: number;
  onClick?: (busTime: BusTime) => void;
};

const BusTimes = ({ atcoCode, limit, showScheduledTime, onClick }: Props) => {
  const { data, isLoading, error } = useBusTimes(atcoCode);

  return (
    <Stack spacing={2}>
      {isLoading ? (
        <>
          {[...new Array(Math.min(limit ?? 99999, 20))].map((e, i) => (
            <Skeleton height="40px" key={i} />
          ))}
        </>
      ) : (
        <>
          {(data?.length ?? 0) > 0
            ? data
                ?.sort((a, b) =>
                  a.expectedDepartureTime.localeCompare(b.expectedDepartureTime)
                )
                .slice(0, limit ?? 99999)
                .map((busTime, i) => (
                  <BusTimeRow
                    showScheduledTime={showScheduledTime}
                    busTime={busTime}
                    key={i}
                    onClick={onClick}
                  />
                ))
            : "No more departures within the next hour"}
        </>
      )}
    </Stack>
  );
};

export default BusTimes;
